import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragScrollComponent, DragScrollItemDirective } from '@le2xx/ngx-drag-scroll';
import { DateFnsModule, FormatPipeModule } from 'lingo2-ngx-date-fns';
import { OnUiCoverModule } from 'onclass-ui';
import { MeetingReviews2Component } from './reviews-carousel-item/meeting-reviews-2.component';
import { ReviewsCarouselComponent } from './reviews-carousel.component';
import {IconComponent} from "@shared/icon/icon.component";

@NgModule({
  declarations: [ReviewsCarouselComponent, MeetingReviews2Component],
    imports: [
        CommonModule,
        DragScrollComponent,
        DragScrollItemDirective,
        DateFnsModule,
        OnUiCoverModule,
        FormatPipeModule,
        IconComponent,
    ],
  exports: [ReviewsCarouselComponent, MeetingReviews2Component],
})
export class ReviewsCarouselModule {}
